module.exports = __webpack_public_path__ + "img/list-pattern3.029c3f6.svg";